import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import useHttp from 'utils/hooks/useHttp';
import {notify} from 'utils/marketplace';
import {AxiosError} from 'axios';
import Spinner from 'components/spinner/Spinner';
import { IConsumable } from 'interfaces/consumable';
import ConsumablePhotoGallery from './ConsumablePhotoGallery/ConsumablePhotoGallery';
import ConsumableDetails from './ConsumableDetails/ConsumableDetails';
import ConsumableOptions from './ConsumableOptions/ConsumableOptions';
import './ConsumablesView.scss';
import { useTranslation } from 'react-i18next';

const ConsumablesView: React.FC = () => {
  const http = useHttp();
  const { id } = useParams<'id'>();
  const {i18n} = useTranslation();

  const [consumables, setConsumables] = useState<IConsumable>();
  const [loading, isLoading] = useState(false);


  useEffect(() => {
    getConsumables();
  }, [i18n.language]);


  const getConsumables = async () => {
    isLoading(true);

    try {

      await http.consumableCatalogHttp.getConsumable(String(id)).then(res=> setConsumables(res.data));

      
    } catch (e: unknown) {

      if(e instanceof AxiosError) {
        const message = e?.response?.data?.detail;

        notify(message);
      }


    } finally {
      isLoading(false);
    }
  };

  return (

    <div className="consumable-wrapper">
      {
        loading ? (
          <Spinner class="small"/>
        ) : (
          <div>
            {
              consumables && (
                <div>
                  <div className="consumable">
                    <div className="gallery">
                      <ConsumablePhotoGallery consumable={consumables}/>
                    </div>
                    <div className="details">
                      <ConsumableDetails consumable={consumables}/>
                    </div>
                    <div className="options">
                      <ConsumableOptions consumable={consumables}/>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  );
};


export default ConsumablesView;